// extracted by mini-css-extract-plugin
export default {"slot":"SidePanelSlot_slot__FTIE1"};